import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { getDateAfterDays, getTodayDate } from "../../carRental/CarRentalBanner";
import { SearchIcon } from "../../../../Utils/svgUrlConstant";

export default function HotelSlugBanner() {

  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      city: "",
      checkInDate: getTodayDate(),
      dropOffDate: getDateAfterDays(3),
      guests: "1 Day",
    },
  });

  const onSubmit = (data) => {
    console.log("Flight Search Payload 👉", data);

    // 👉 API call / navigation logic here
    // navigate(`/flight/${data.destination}`)
  };
  return (
    <div className="flightSlugbanContainer">
      <h1>Hotels Search</h1>
      <div className="flight-booking-form">
        <div className="tab-content" id="pills-tabContent">
          <div className="tab-pane fade show active" id="pills-home" role="tabpanel"
            aria-labelledby="pills-home-tab" tabIndex="0">
            <form className="booking-search-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="row gy-3">
                <div className="col-md-6">
                  <div className="search-item">
                    <label className="form-label">City or hotel name</label>
                    <div className="input-group custom-input flex align-items-center gap-3 bg-white ">
                      <span><svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.75 20.75V14.18M8.75 9.75H9.75M8.75 5.75H9.75M10.75 14.18V20.75M11.75 14.75C10.8845 14.1009 9.83185 13.75 8.75 13.75C7.66815 13.75 6.61548 14.1009 5.75 14.75M13.75 9.75H12.76M13.75 5.75H12.76M4.75 9.75H4.76H5.75M4.75 5.75H5.75M2.75 0.75H14.75C15.8546 0.75 16.75 1.64543 16.75 2.75V18.75C16.75 19.8546 15.8546 20.75 14.75 20.75H2.75C1.64543 20.75 0.75 19.8546 0.75 18.75V2.75C0.75 1.64543 1.64543 0.75 2.75 0.75Z" stroke="#1A1E18" strokeWidth="1.5" />
                      </svg></span>
                      <input type="text" className="shadow-none outline-0 border-0 form-control p-0 bg-transparent"
                        placeholder="City or hotel name" {...register("city", { required: "City / Hotel name is required" })} />
                    </div>
                    {errors.city && <p className="text-danger small">{errors.city.message}</p>}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="search-item check_in">
                    <label className="form-label">Check-In</label>
                    <input type="date" className="form-control bg-white"  {...register("checkIn", { required: "Check-in date is required" })} />
                    {errors.checkIn && <p className="text-danger small">{errors.checkIn.message}</p>}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="search-item check_in">
                    <label className="form-label">Check-Out</label>
                    <input type="date" className="form-control bg-white" {...register("checkOut", { required: "Check-out date is required" })} />
                    {errors.checkOut && <p className="text-danger small">{errors.checkOut.message}</p>}
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="search-item">
                    <label className="form-label">Guests</label>
                    <div className="input-group custom-input flex align-items-center gap-3 bg-white">
                      <input
                        type="number"
                        className="shadow-none outline-0 border-0 form-control p-0 bg-transparent"
                        placeholder="Number of days"
                        min={1}
                        {...register("guests", {
                          required: "Number of days is required",
                          min: {
                            value: 1,
                            message: "Minimum 1 day required",
                          },
                        })}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 align-content-end">
                  <div className="search-item">
                    <button
                      className="view-all-btn w-100 justify-content-center gap-2 align-items-center">
                      <i className="fa-solid fa-magnifying-glass"></i> Search
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="tab-pane fade" id="pills-profile" role="tabpanel"
            aria-labelledby="pills-profile-tab" tabIndex="0">

          </div>

        </div>
      </div>

    </div>
  )
}
